import { render, staticRenderFns } from "./Rtl.vue?vue&type=template&id=2487a4f8"
import script from "./Rtl.vue?vue&type=script&lang=js"
export * from "./Rtl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports